import { useLocale } from '@gov-nx/core/service';
import {
	formatPersonLabel,
	useProfilROSDetailContext,
} from '@gov-nx/module/page';
import { DataTable, Dialog, LayoutGap } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';

export const MembersListModal = () => {
	const { isMembersListModalOpen, members, code } = useProfilROSDetailContext();
	const { t } = useLocale(code);

	return (
		<Dialog
			isOpen={isMembersListModalOpen.isTrue}
			onClose={isMembersListModalOpen.setFalse}
			title={<h3>{t('modal.label.seznam-clenu')}</h3>}>
			<LayoutGap gap="s">
				<p>{t('modal.popis.seznam-clenu')}</p>
				<ol className="list-none pl-0! ol-custom-counter">
					{members.map((member) => (
						<li
							key={[
								member.ico,
								member.sidloSpolecnosti?.adresaText,
								member.datumNarozeni,
							].join(',')}>
							<p className="py-(--templates-margin-s)!">&nbsp;</p>
							<DataTable responsive>
								<tbody>
									<tr>
										<td className="sm:w-1/2">{t('modal.zaznam.jmeno')}</td>
										<td className="sm:w-1/2">
											<strong>{formatPersonLabel(member)}</strong>
										</td>
									</tr>
									<tr>
										<td>{t('modal.zaznam.adresa-pobytu')}</td>
										<td>
											<strong>
												{member?.sidloSpolecnosti?.adresaText ?? '-'}
											</strong>
										</td>
									</tr>
									<tr>
										<td>{t('modal.zaznam.datum-narozeni')}</td>
										<td>
											<strong>
												{member?.datumNarozeni
													? toDateReadable(member.datumNarozeni)
													: '-'}
											</strong>
										</td>
									</tr>
								</tbody>
							</DataTable>
						</li>
					))}
				</ol>
			</LayoutGap>
		</Dialog>
	);
};
